import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './Image.styles';

const Image = props => {
  let { alt, styles: customStyles, ...rest } = props;
  return <img className={css(styles.base, customStyles)} alt={alt} {...rest} />;
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/common/image/Image.js